import { render, staticRenderFns } from "./sor-items.vue?vue&type=template&id=6e875a7c&"
import script from "./sor-items.vue?vue&type=script&lang=js&"
export * from "./sor-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports